/* ============================================================
   The accent palette's NAMES — the enum the server stores and every record
   carries. Only the names live here; what colour each one paints is the
   front end's business (app/src/theme.ts, desktop's tokens), and the two
   front ends may disagree on the pixels as long as they agree on the names.
   ============================================================ */

/* per-item accent hues — see theme.ts in each front end for the swatches */
export type HueName =
  | 'teal'
  | 'orange'
  | 'purple'
  | 'pink'
  | 'blue'
  | 'green'
  | 'yellow';

/** The order a new project or tag is handed a colour in (store/logic.ts
   nextProjectHue / nextTagHue): the first hue nothing live is using. */
export const HUE_ORDER: HueName[] = [
  'teal',
  'orange',
  'purple',
  'pink',
  'blue',
  'green',
  'yellow',
];

/** The appearance preference as the server stores it (ServerPreferences). */
export type ThemePref = 'light' | 'dark' | 'system';
